import { useCallback } from 'react';
import { useClientTokenManager } from '../../context/ClientTokenContext';
export const usePermissions = () => {
    const { tokenProperties } = useClientTokenManager();
    const { permissions = [] } = tokenProperties;
    const hasPermission = useCallback((permission) => permissions?.length ? Boolean(permissions.includes(permission)) : null, [permissions]);
    return { hasPermission };
};
